<template>
  <div class="legal-page">
    <div class="container">
      <h1>隐私政策</h1>
      <p class="last-updated">生效日期：2025年10月27日</p>

      <p>深圳灵动帧智能科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全。本《隐私政策》（以下简称“本政策”）旨在向您说明，当您使用我们的网站（www.lingdongzhen.com）及提供的服务（包括但不限于视频下载、音频处理、图片修复、电子书格式转换、视频换脸、语音克隆等，统称“服务”）时，我们如何处理您的信息。</p>

      <p><strong>我们承诺：</strong>我们不会收集您的设备信息、网络日志、IP地址、Cookie或任何类似追踪技术；不支持电子邮箱注册或社交媒体账号登录；除为提供服务所必需外，不存储任何个人信息；用户上传的原始文件在处理完成后将立即删除。</p>

      <ol class="policy-list">
        <li>
          <h2>我们如何收集和使用您的信息</h2>
          <ul>
            <li><strong>账户信息：</strong>您可以通过以下两种方式登录我们的服务：
              <ul>
                <li>使用手机号作为账号，并设置密码进行注册和登录；</li>
                <li>通过手机号接收验证码，验证后直接登录。</li>
              </ul>
              我们仅记录您的手机号（作为唯一账号标识）以及必要的密码（加密存储），不收集姓名、生日、性别、地址等其他个人信息。
            </li>
            <li><strong>您上传的文件内容：</strong>为实现服务功能（如格式转换、修复、翻译、克隆等），您需上传视频、音频、图片或电子书文件。这些文件将被视为您的“用户内容”。我们仅在处理过程中临时访问这些内容，处理完成后即删除原始文件。</li>
            <li><strong>无自动信息收集：</strong>我们不会收集任何设备信息（如设备型号、操作系统）、日志信息（如IP地址、访问时间）、Cookie 或其他追踪技术。您使用服务时的行为不会被记录或分析。</li>
          </ul>
        </li>

        <li>
          <h2>我们如何存储您的信息</h2>
          <ul>
            <li><strong>存储位置：</strong>您上传的文件仅用于即时处理，临时存储于我们合作的第三方云服务商——七牛云（Qiniu Cloud）的服务器中，数据中心位于中华人民共和国境内。</li>
            <li><strong>存储期限：</strong>
              <ul>
                <li>用户上传的原始文件：在完成处理任务后<strong>立即删除</strong>，最长不超过24小时。</li>
                <li>处理后的结果文件：默认在系统中保留<strong>24小时</strong>供您下载，超时后自动清除。</li>
                <li>账户信息（手机号及加密密码）：将持续保留，直至您主动注销账户。</li>
              </ul>
            </li>
            <li><strong>安全保障：</strong>我们采取符合行业标准的安全措施保护您的数据，包括传输过程中的SSL/TLS加密、严格的访问权限控制。七牛云也具备完善的数据安全与合规保障机制。</li>
          </ul>
        </li>

        <li>
          <h2>我们如何共享、转让和公开披露您的信息</h2>
          <p>我们不会出售、出租或以任何形式非法共享您的个人信息。仅在以下情况下可能涉及信息处理：</p>
          <ul>
            <li><strong>服务支持：</strong>为完成文件处理与存储，您的用户内容会由七牛云提供临时存储服务。七牛云作为数据处理方，仅按我们的指令操作数据，并承担保密义务。</li>
            <li><strong>法律要求：</strong>当依法应政府机关、司法机构或监管部门要求时，我们可能在必要范围内披露相关信息。</li>
            <li><strong>业务变更：</strong>如发生公司合并、收购或资产转让，您的信息可能作为整体业务的一部分被转移，但我们会在转移前确保接收方继续履行同等隐私保护责任。</li>
          </ul>
        </li>

        <li>
          <h2>您的权利</h2>
          <p>您对自己的信息拥有充分控制权：</p>
          <ul>
            <li><strong>删除文件：</strong>您可在任何时候删除已上传的文件或处理结果。</li>
            <li><strong>注销账户：</strong>您可随时申请注销账户。账户注销后，我们将删除与该账户关联的所有信息（法律法规要求保留的除外）。</li>
            <li><strong>获取信息副本：</strong>您有权请求获取您账户信息的副本。</li>
            <li><strong>撤回同意：</strong>您可随时撤回对我们处理您信息的同意，但这可能影响您继续使用部分服务。</li>
          </ul>
          <p>如需行使上述权利，请通过本政策末尾的联系方式与我们联系。</p>
        </li>

        <li>
          <h2>未成年人保护</h2>
          <p>我们的服务不面向14周岁以下的儿童。我们不会在知情的情况下收集该年龄段儿童的个人信息。如果您是监护人并发现我们收集了您孩子的信息，请联系我们，我们将立即删除相关数据。</p>
        </li>

        <li>
          <h2>政策的变更</h2>
          <p>我们可能会根据业务发展或法律要求更新本隐私政策。更新后的内容将在网站显著位置公示，并更新生效日期。建议您定期查看本政策以了解最新信息。</p>
        </li>

        <li>
          <h2>如何联系我们</h2>
          <p>如果您对本隐私政策有任何疑问、意见、投诉或需要行使您的权利，请通过以下方式联系我们：</p>
          <ul>
            <li>邮箱：wuyunxiong_cse@163.com</li>
            <li>电话：19872424497</li>
            <li>地址：深圳市南山区粤海街道高新区社区白石路3609深圳湾科技生态园2区9栋514-549</li>
          </ul>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  mounted () {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin-top: -40px;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.legal-page h1 {
  text-align: center;
  font-size: 2.2rem;
  color: #1a59b1;
  margin-bottom: 10px;
}

.last-updated {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  margin-bottom: 30px;
}

.policy-list {
  counter-reset: item;
  list-style: none;
  padding-left: 0;
}

.policy-list > li {
  margin-bottom: 30px;
  counter-increment: item;
  position: relative;
}

.policy-list > li::before {
  content: counter(item) ".";
  position: absolute;
  left: -40px;
  top: 0;
  font-weight: bold;
  font-size: 1.1rem;
  color: #4f46e5;
  width: 30px;
  text-align: right;
}

.policy-list h2 {
  color: #1f2937;
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.policy-list p,
.policy-list li {
  color: #374151;
  margin-bottom: 10px;
  line-height: 1.7;
}

.policy-list ul {
  margin: 10px 0;
  padding-left: 20px;
}

.policy-list ul ul {
  margin-top: 5px;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  .container {
    padding: 20px;
    margin: 10px;
  }
  .legal-page h1 {
    font-size: 1.8rem;
  }
  .policy-list > li::before {
    left: -30px;
  }
}
</style>
